import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.ConversationOrderSummary'

export default defineMessages({
  heading: {
    id: `${scope}.heading`,
    defaultMessage: 'Requesting {count, plural, one {# item} other {# items}}',
  },
  groupHeading: {
    id: `${scope}.groupHeading`,
    defaultMessage:
      'Requesting {count, plural, one {# item} other {# items}} from',
  },
  vendorSubtotal: {
    id: `${scope}.vendorSubtotal`,
    defaultMessage: '{vendor} subtotal',
  },
  estimatedTotal: {
    id: `${scope}.estimatedTotal`,
    defaultMessage: 'Estimated total',
  },
  checkoutHeading: {
    id: `${scope}.checkoutHeading`,
    defaultMessage: 'Order summary',
  },
  shipTo: {
    id: `${scope}.shipTo`,
    defaultMessage: 'Ship to',
  },
  billTo: {
    id: `${scope}.billTo`,
    defaultMessage: 'Bill to',
  },
  paymentMethod: {
    id: `${scope}.paymentMethod`,
    defaultMessage: 'Payment method',
  },
  changePaymentMethod: {
    id: `${scope}.changePaymentMethod`,
    defaultMessage: 'Update payment method',
  },
  deliveryHeading: {
    id: `${scope}.deliveryHeading`,
    defaultMessage: 'Delivery {index}',
  },
  deliveryItemCount: {
    id: `${scope}.deliveryItemCount`,
    defaultMessage: '• {count, plural, one {# item} other {# items}}',
  },
  deliverBy: {
    id: `${scope}.deliverBy`,
    defaultMessage: 'Deliver by {date}',
  },
  unitPrice: {
    id: `${scope}.unitPrice`,
    defaultMessage: '{price} each',
  },
  quantityLabel: {
    id: `${scope}.quantityLabel`,
    defaultMessage: 'Qty: {quantity}',
  },
  total: {
    id: `${scope}.total`,
    defaultMessage: 'Total',
  },
  continueButton: {
    id: `${scope}.continueButton`,
    defaultMessage: 'Continue to order request form',
  },
  disclaimer: {
    id: `${scope}.disclaimer`,
    defaultMessage:
      'These details will pre-fill the order request form, ready for you to review and submit.',
  },
  quantityAriaLabel: {
    id: `${scope}.quantityAriaLabel`,
    defaultMessage: 'Quantity of {name}',
  },
  increaseQuantityAriaLabel: {
    id: `${scope}.increaseQuantityAriaLabel`,
    defaultMessage: 'Increase quantity of {name}',
  },
  decreaseQuantityAriaLabel: {
    id: `${scope}.decreaseQuantityAriaLabel`,
    defaultMessage: 'Decrease quantity of {name}',
  },
  removeItemAriaLabel: {
    id: `${scope}.removeItemAriaLabel`,
    defaultMessage: 'Remove {name}',
  },
})
